// material-ui
import { useTheme } from '@mui/material/styles';
import { Container, Grid, Stack, Typography, Card, CardContent, Box } from '@mui/material';

// icons
import AnalyticsIcon from '@mui/icons-material/Analytics';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import SchoolIcon from '@mui/icons-material/School';

// =============================|| LANDING - FRAMWORK SECTION ||============================= //

const FrameworkSection = () => {
    const theme = useTheme();

    return (
        <>
            <Container sx={{ mb: 6 }}>
                <Stack spacing={0.25} alignItems="center">
                    <Typography variant="h2" align="center" sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                        Dịch vụ
                    </Typography>
                    <Typography variant="h5" align="center" sx={{ pt: 1 }}>
                        "DataHub cung cấp các dịch vụ toàn diện về quản lý dữ liệu doanh nghiệp. Từ tư vấn chiến lược, triển khai hệ thống
                        đến đào tạo chuyên sâu - chúng tôi đồng hành cùng doanh nghiệp trong hành trình chuyển đổi số."
                    </Typography>
                </Stack>
                <Grid container>
                    <Grid item xs={12} sm={12} md={4}>
                        <Card
                            sx={{
                                height: '100%',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow:
                                        theme.palette.mode === 'dark' ? '0 20px 40px rgba(0,0,0,0.3)' : '0 20px 40px rgba(0,0,0,0.1)',
                                    '& .service-icon': {
                                        transform: 'scale(1.1) rotate(5deg)'
                                    }
                                }
                            }}
                        >
                            <Box sx={{ height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <AnalyticsIcon
                                    className="service-icon"
                                    sx={{ fontSize: 80, color: '#3B82F6', transition: 'all 0.3s ease' }}
                                />
                            </Box>
                            <CardContent>
                                <Typography
                                    gutterBottom
                                    sx={{ textAlign: 'center', paddingBottom: 2, borderBottom: '1px solid #156DA2' }}
                                    variant="h3"
                                    component="div"
                                >
                                    Tư vấn
                                </Typography>
                                <Typography variant="body1" sx={{ textAlign: 'justify', fontSize: '16px' }} color="text.secondary">
                                    Đội ngũ chuyên gia DataHub tư vấn chiến lược dữ liệu toàn diện, từ kiến trúc hệ thống, quy trình xử lý
                                    dữ liệu đến phân tích và khai thác insights. Chúng tôi giúp doanh nghiệp xây dựng roadmap phù hợp với
                                    mục tiêu kinh doanh.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <Card
                            sx={{
                                height: '100%',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow:
                                        theme.palette.mode === 'dark' ? '0 20px 40px rgba(0,0,0,0.3)' : '0 20px 40px rgba(0,0,0,0.1)',
                                    '& .service-icon': {
                                        transform: 'scale(1.1) rotate(5deg)'
                                    }
                                }
                            }}
                        >
                            <Box sx={{ height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <RocketLaunchIcon
                                    className="service-icon"
                                    sx={{ fontSize: 80, color: '#8B5CF6', transition: 'all 0.3s ease' }}
                                />
                            </Box>

                            <CardContent>
                                <Typography
                                    gutterBottom
                                    sx={{ textAlign: 'center', paddingBottom: 2, borderBottom: '1px solid #156DA2' }}
                                    variant="h3"
                                    component="div"
                                >
                                    Triển khai
                                </Typography>
                                <Typography variant="body1" sx={{ textAlign: 'justify', fontSize: '16px' }} color="text.secondary">
                                     DataHub triển khai hệ thống end-to-end với đội ngũ kỹ thuật chuyên nghiệp. Từ cài đặt JupyterHub,
                                    Airflow, MongoDB đến tích hợp multi-cloud storage, chúng tôi đảm bảo hệ thống hoạt động ổn định, bảo mật
                                    và đáp ứng yêu cầu scale của doanh nghiệp.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <Card
                            sx={{
                                height: '100%',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow:
                                        theme.palette.mode === 'dark' ? '0 20px 40px rgba(0,0,0,0.3)' : '0 20px 40px rgba(0,0,0,0.1)',
                                    '& .service-icon': {
                                        transform: 'scale(1.1) rotate(5deg)'
                                    }
                                }
                            }}
                        >
                            <Box sx={{ height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <SchoolIcon className="service-icon" sx={{ fontSize: 80, color: '#10B981', transition: 'all 0.3s ease' }} />
                            </Box>
                            <CardContent>
                                <Typography
                                    gutterBottom
                                    sx={{ textAlign: 'center', paddingBottom: 2, borderBottom: '1px solid #156DA2' }}
                                    variant="h3"
                                    component="div"
                                >
                                    Đào tạo
                                </Typography>
                                <Typography variant="body1" sx={{ textAlign: 'justify', fontSize: '16px' }} color="text.secondary">
                                    Chương trình đào tạo DataHub được thiết kế cho mọi cấp độ người dùng. Từ khóa học cơ bản về quản lý dữ
                                    liệu, phát triển notebooks Python/R đến workshop chuyên sâu về xây dựng ML pipelines và tối ưu hóa
                                    workflows. Đào tạo theo yêu cầu riêng của doanh nghiệp.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default FrameworkSection;
